export default __webpack_public_path__ + "static/media/img_main-wallet.dc59e76b.png";